// Global Passive Events Fix
// This patches the native addEventListener to make scroll-blocking events passive by default

(() => {
  // Only run in browser environment
  if (typeof window === 'undefined' || typeof EventTarget === 'undefined') {
    return;
  }

  // Check if passive events are supported
  let supportsPassive = false;
  try {
    const opts = Object.defineProperty({}, 'passive', {
      get() {
        supportsPassive = true;
        return false;
      }
    });
    window.addEventListener('testPassiveSupport', null, opts);
    window.removeEventListener('testPassiveSupport', null, opts);
  } catch (e) {
    // Passive not supported
  }

  if (!supportsPassive) {
    return; // Exit if passive not supported
  }

  // Store the original addEventListener
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  const originalRemoveEventListener = EventTarget.prototype.removeEventListener;

  // Events that should be passive by default for better performance
  const passiveEventTypes = [
    'wheel',
    'mousewheel',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'scroll',
    'resize'
  ];

  // Override addEventListener
  EventTarget.prototype.addEventListener = function(type, listener, options) {
    // Handle different options formats
    let capture = false;
    let passive = false;
    let once = false;

    if (typeof options === 'boolean') {
      capture = options;
    } else if (typeof options === 'object' && options !== null) {
      capture = Boolean(options.capture);
      passive = Boolean(options.passive);
      once = Boolean(options.once);
    }

    // Make certain events passive by default unless explicitly set to false
    if (passiveEventTypes.includes(type) && options !== false && !passive) {
      // Only make it passive if it wasn't explicitly set to false
      if (typeof options !== 'object' || options.passive !== false) {
        passive = true;
        // console.log(`Making ${type} event passive on`, this.tagName || this.constructor.name);
      }
    }

    // Reconstruct options object
    const newOptions = typeof options === 'boolean'
      ? capture
      : { capture, passive, once };

    return originalAddEventListener.call(this, type, listener, newOptions);
  };

  // Override removeEventListener to maintain compatibility
  EventTarget.prototype.removeEventListener = function(type, listener, options) {
    return originalRemoveEventListener.call(this, type, listener, options);
  };

  console.log('Global passive events fix applied');
})();
